export default "__VITE_ASSET__9cb99bde__"